export const constants = {
  format: (source, params) => {
    // eslint-disable-next-line no-sequences
    return source, [...params];
  },
  FIRST_NAME: "First Name",
  EMAIL_ADDRESS: "Email Address",
  ENTER_PASSWORD: "Enter Password",
  USER_NAME: "User Name",
  CONFIRM_PASSWORD: "Confirm Password",
  PASSWORD: "Password",
  REGISTER: "Register",
  SIGN_IN_MSG: "Already a member? Sign In here",
  STUDENT: "student",
  PATIENT: "patient",
  PAKQATAR: "PakQatar",
  COUNSELLOR: "Counsellor",
  COUNSELLORS: "Counsellors",
  PATIENTS: "Patient",
  APPOINTMENTS: "Appointments",
  IBA: "IBA",
  EMAIL: "email",
  ENTER_YOU_EMAIL: "Enter your {0} email",
  TERMS_CONDITIONS_MSG: "Please check our Terms and condition",
  FILL_ALL_FIELDS_MSG: "Please fill all the fields",
  REGISTER_MEMBER_MSG: "Register a new membership",
  SIGN_IN_SESSION: "Administrator Sign In",
  SIGN_IN: "Sign In",
  COUNSELOR_LOGIN_MSG: "Are you a {0}? Sign In here",
  FORGOT_PASSWORD_MSG: "Forgot your Password",
  CHECKING_TERMS_TXT: "By checking this, you agree to our ",
  TERMS_CONDITIONS_TXT: "Terms and Condition",
  REGISTERED: "registered",
  PLEASE_TXT: "Please",
  CHOOSE_YOUR_PROJECT: "CHOOSE YOUR PROJECT(S)",
  MARK_PROJECT_AVAILABILITY: "UPDATE PROJECT(S) STATUS",
  NO_PROJECT_SELECTED: "You didnt selected any project",
  TOTAL_SESSION_CAP_TXT: "Total session cap",  
  PATIENT_SESSION_CAP_TXT: "Patient session cap",  
  IS_SESSION_CAP_ALLOWED_TXT: "Is session cap allowed",  

  MOBILE_USER_NAME: "Name",
  MOBILE_SIGN_IN_SESSION: "Administrator Sign In",
  MOBILE_ENTER_YOU_EMAIL: "Email",
  MOBILE_EMAIL_ADDRESS: "Email",
  MOBILE_COUNSELOR_LOGIN_MSG: "Are you a {0}?",
  MOBILE_COUNSELOR_LOGIN_MSG_LINK: "Sign In here",
  MOBILE_FORGOT_PASSWORD_MSG: "Forgot Password",
  MOBILE_REGISTER_MEMBER_MSG:
    "Continue your journey towards a happier & healthier you!",
  MOBILE_CONFIRM_PASSWORD: "Confirm Password",
  MOBILE_PASSWORD: "Password",
  MOBILE_CHECKING_TERMS_TXT: "By checking this,agree to the terms of use and ",
  MOBILE_TERMS_CONDITIONS_TXT: "privacy policy.",
  MOBILE_SIGN_IN_MSG: "Already a member? ",
  MOBILE_SIGN_IN_MSG_LINK: "Sign In here",
  EMAIL_VALIDATION_MSG: "Enter a valid email address",
  COUNSELLOR_LOGIN: "Counsellor Login",
  REPORTS_TEXT: "Reports",
  NOTES_TEXT: "your notes",
  SCHEDULE_SESSION_TEXT: "schedule a session",
  HELP_TEXT: "We’re here to help",
  CONTACT_US_TEXT: "Contact Us",
  SUBMIT_TEXT: "Submit",
  TOP_QUESTIONS_TEXT: "Top Questions",
  SUCCESS_TEXT: "success",
  ERROR_TEXT: "error",
  CONTACT_US_SUCCESS_MSG: "Your request has been successfully sent",
  CONTACT_US_FAILURE_MSG: "Your request cannot be registered at this time",
  UNSUPPORTED_MSG_TITLE: "Oh Snap!",
  UNSUPPORTED_MSG_BODY:
    "We can not find your camera or microphone to initiate this call. Please check if you have given the permissions, or contact us at contact@saayahealth.com with screenshot.",
  FAQ_EMPTY_MSG: "There are no queries registered at the moment",
  DESCRIPTION_LENGTH_ERROR_MSG:
    "Description should contain atleast 10 characters",
  NO_PATIENTS_MSG: "No Patient Available",
  PST_MSG: "Pakistan Standard Time",
  CREATE_APPOINTMENT_TXT: "Create Appointment",
  SELECT_DAY_TXT: "Select Day",
  SELECT_TIME: "Select Time",
  SELECT_USER_TXT: "Select User",
  CANCEL_TXT: "Cancel",
  SUBMIT_TXT: "Submit",
  MANAGE_SCHEDULE_TXT: "Manage your schedule",
  MANAGE_AVAILABILITY_TXT: "Manage your availability for new clients",
  VIEW_SLOTS_TXT: "View Slots",
  REGISTER_SLOTS: "Register Slots",
  YOUR_NEXT_SESSION_TXT: "Your next session",
  PATIENT_NAME_TXT: "Patient Name",
  WHEN_TXT: "When",
  NO_APPOINTMENTS_TXT: "No appointments to show",
  SELECT_USER_ERROR_MSG: "Select a user to continue the request.",
  SELECT_COUNSELLOR_ERROR_MSG: "Select a counsellor to continue the request.",
  NO_SUBSIDIARY_TXT: "No Subsidiary to select",
  SELECT_SUBSIDIARY_ERROR_MSG: "Select a subsidiary to continue the request.",
  SUBSIDIARY_PLACEHOLDER_TXT: "Select subsidiary",
  ENTER_NEW_PWD_TXT: "Enter Your New Password",
  ENTER_NEW_PWD: "Enter new Password",
  NEW_PWD_TXT: "New password",
  REPEAT_PWD_TXT: "Repeat Password",
  CONFIRM_PWD: "Confirm password",
  UPDATE_PWD_TXT: "Update password",
  REOURCE_IN_USE_ERROR:
    "We could not connect to your selected camera since it may be in use by another application.",
  RESEOURCE_NOT_FOUND_ERROR:
    "We could not find any camera or microphone connected to your device.",
  SESSION_GENERAL_ERROR:
    "We are unable to join the session at the moment, Please try again",
  ADMIN_PANEL_TXT: "Admin Panel",
  WHITELABELS_TXT: "Whitelabels",
  CREATE_WHITELABEL_TXT: "Create Whitelabel",
  LIST_WHITELABEL_TXT: "List Whitelabels",
  CREATE_COUNSELLOR_TXT: "Create Counsellors",
  LIST_COUNSELLORS_TXT: "List Counsellors",
  CORPORATE_REPORTS_TXT: "Corporate Reports",
  COUNSELLOR_REPORTS_TXT: "Counsellor Reports",
  CREATE_APPOINTMENT_TXT: "Create Appointment",
  APPOINTMENT_TXT: "Appointments",
  PAYMENT_REQUIRED_TXT: "Payment Required",
  CONSUMER_ROLE_TXT: "Consumer Role",
  PRODUCER_ROLE_TXT: "Producer Role",
  SUBSIDIARIES_TXT: "Sub companies (Provide multiple with comma)",
  EMAIL_DOMAIN_TXT: "Email domains (Provide multiple with comma)",
  DOMAIN_TXT: "Domain",
  UPLOAD_LOGO_TXT: "Upload Logo",
  NAME_TXT: "Name",
  WHITELABEL_TXT: "Whitelabels",
  UPDATE_WHITELABEL_TXT: "Update Whitelabel",
  CREATE_TXT: "Create",
  SAVE_TXT: "Save",
  USD_TXT: "USD",
  NOT_PROVIDED_TXT: "N/A",
  RELATION_WITH_WHITELABEL_TXT: "Relationship with Whitelabel",
  QUALIFICATION_TXT: "Qualification",
  ENTER_QUALIFICATIONS_TXT: "Enter qualifications here",
  AREA_OF_FOCUS_TXT: "Areas of Focus",
  AREA_OF_FOCUS_PLACEHOLDER_TXT: "Enter areas of focus here",
  PRICE_TXT: "Price",
  PRICE_USD_TXT: "Price (USD)",
  PRICE_PKR_TXT: "Price (PKR)",
  SELECT_SERVICE_TYPE_TXT: "Select service type",
  HOME_CITY_TXT: "Home City",
  HOME_CITY_PLACEHOLDER_TXT: "Enter home city here",
  EMAIL_TXT: "Email address",
  PHONE_TXT: "Phone Number",
  EXPERT_AREA: "Expert Area",
  UPLOAD_IMAGE_TXT: "Upload Image",
  NAME_PLACEHOLDER_TXT: "Enter counsellor name here",
  PATIENT_NAME_PLACEHOLDER_TXT: "Enter Patient name here",
  EMAIL_PLACEHOLDER_TXT: "Enter email address here",
  PASSWORD_PLACEHOLDER_TXT: "Enter Password atleast 6 digit long",
  PHONE_PLACEHOLDER_TXT: "Enter phone number here",
  PRICE_PLACEHOLDER_TXT: "Enter counsellor fees here",
  WHITELABLE_PLACEHOLDER_TXT: "Enter Whitelabel here",
  SEARCH_TXT: "Search",
  PERMISSIONS_TXT: "You would need permissions to perform this operation",
  EDIT_TXT: "Edit",
  DELETE_TXT: "Delete",
  ACTIVE_TXT: "ACTIVE",
  NO_WHITELABELS_TXT: "No Whitelabels exists",
  EMAIL_DOMAINS_TXT: "Email domains allowed",
  PAYMENT_TXT: "Payment",
  LANGUAGES_TXT: "Languages spoken",
  PATIENTS_EMAIL:"Patients Email",
  SCHEDULE:"Schedule",
  PROJECT:"Project",
  SUBSIDIARY:"Subsidary",
  NO_OF_TOTAL_SESSION:"No of total Session",
  SHOWING:"Showing",
  RECORDS:"records",
  PDF:"PDF",
  EXCEL:"Excel",
  SERVICE_TYPE_TXT:'Service type',
  TOTAL_SESSION_CAP:'Total session cap',
  SAAYA_HEALTH_TXT:'Saaya Health',
  GENERAL_ERROR_TXT:'An error occurred while processing.',
  SUCCESS_PROJECT_CREATED: "Your project has been created successfully!",
  SUCCESS_PROJECT_UPDATED: "Your project has been updated successfully!",
  NATURE_OF_ISSUE:'Nature of issues',
  SEE_MORE:'See more',
  NO_ISSUES_DISPLAY_TXT:'No issues to display',
  EMAIL: "contact@saayahealth.com",
  WHATSAPP_SUPPORT: "0097335317168",
  WHATSAPP_SUPPORT_TEXT: "Whatsapp Customer Support",
  COPYRIGHT_TEXT: "Copyright",
  CHANGE_PASSWORD_TXT: 'Change Password',
  INFO_TXT: 'info',
  OK_TXT: 'Ok',
  WRONG_PASSWORD_TXT: 'Wrong Password',
  PASSWORD_MISMATCH_TXT: 'Please enter the same password in both fields!',
  ARE_YOU_SURE_TXT: 'Are you sure!',
  DELETE_CONFIRMATION_MESSAGE_TXT: 'You are going to delete this whitelabel!',
  WARNING_TXT: 'warning',
  YES_TXT: 'Yes',
  NO_TXT: 'No',
  DELETE_COUNSELLOR_TXT: "You are going to delete this counsellor!",
  CONTACT_ADMINISTRATOR_TXT: "Contact Administrator?",
  APPOINTMENT_CREATED_TXT: "Appointment has been created successfully!",
  APPOINTMENT_CAN_NOT_CREATED_TXT: "Appointment cannot be created at this time.",
  PASSWORD_CHANGED_SUCCESS_TXT: "Your password has successfully been changed!",
  EMAIL_SENT_TITLE_TXT: "Email sent!",
  EMAIL_SENT_MESSAGE_TXT: "Please check your inbox, an email is on the way.",
  EMAIL_NOT_REGISTERED_TXT: "Email not registered!",
  EMAIL_NOT_REGISTERED_TXT: "Provided email is not registered.",
  COUNSELLOR_CREATED_UPDATED_SUCCESS_TXT: (action) => `Your counsellor has been ${action} successfully!`,
  COUNSELLOR_CREATED_UPDATED_FAILURE_TXT: (action) => `Your counsellor is failed to be ${action}!`,
  INVALID_LOGO_ERROR_TXT: 'Please select a valid .jpg or .png file',
  SELECT_LOGO_ERROR_TXT: 'Please select picture of counsellor',
  IS_FAMILY_MEMBER_ALLOWED_TXT: "Is family member allowed",  
  ENTER_NAME_ERROR_TXT:'Please enter name',
  ENTER_VALID_NAME_ERROR_TXT:'Please enter a valid name',
  SELECT_SERVICE_TYPE_ERROR_TXT:'Please select atleast one service type',
};



// WEBPACK FOOTER //
// ./src/Constants.js